import { DestroyRef, Injectable, inject, signal } from '@angular/core';

const MOBILE_QUERY = '(max-width: 767px)';

@Injectable({ providedIn: 'root' })
export class ViewportService {
  private readonly destroyRef = inject(DestroyRef);

  private readonly _isMobile = signal<boolean>(matchesMobile());
  readonly isMobile = this._isMobile.asReadonly();

  constructor() {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      const mq = window.matchMedia(MOBILE_QUERY);
      const onChange = (e: MediaQueryListEvent) => this._isMobile.set(e.matches);
      mq.addEventListener('change', onChange);
      this.destroyRef.onDestroy(() => mq.removeEventListener('change', onChange));
    }
  }
}

function matchesMobile(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(MOBILE_QUERY).matches;
}
